/**
 * @file topic-content-actions
 */
import toast from '@/utils/decorate/toast';
import topicActions from './topic';
import replyActions from './reply';
import officialProcessActions from './officialProcess';
import {notAllowScroll, allowScroll} from '@/utils/decorate/scroll';

export default {
    getWholeTopicContent({dispatch, state}, {id, type, pageNo}) {
        let query = {id};
        if (type) {
            query.type = type;
        }
        return dispatch('getTopicContent', query)
            .then(() => {
                let query = {topicId: state.topicData.topicInfo.topicId};
                if (pageNo) {
                    query.pageNo = pageNo;
                }
                dispatch('getReplyContent', {query});
            })
            .catch(errmsg => {
                if (!errmsg) {
                    toast.error('帖子不存在');
                    return Promise.reject(errmsg);
                }
                if (typeof errmsg === 'string' && errmsg.indexOf('issue not topic') > -1) {
                    return Promise.reject(errmsg);
                }
                if (typeof errmsg === 'string' && errmsg.indexOf('当前界面仅发帖人可查看，请确认登录身份') > -1) {
                    toast.error(errmsg);
                    location.assign('https://ossunion.baidu.com/opensource/index.html');
                    return Promise.reject(errmsg);
                }
                this.$router.replace('/');
            });
    },
    toggle({state, commit}, confirmName) {
        commit('changeConfirmState', confirmName);
        if (state[confirmName]) {
            notAllowScroll();
        }
        else {
            allowScroll();
        }
    },
    ...topicActions,
    ...replyActions,
    ...officialProcessActions
};
